<template>
  <PortalPageShell
    :title="pageTitle"
    subtitle="Configure how this status appears and where it is used"
  >
  <div class="portal-form-card edit-status form-group">
    <div class="card shadow-sm border-0">
      <div class="card-header bg-white border-0 pt-4 pb-0 d-none">
      </div>
      <div class="card-body">
        <div class="loader" v-if="loading"></div>
        <div class="form-group">
          <label class="field-label" for="display_name">{{ $t('flightstatus.editstatus.name') }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text bg-white"><span class="mdi mdi-rename-box"></span></span>
            </div>
            <input class="form-control" type="text" id="display_name" :placeholder="$t('flightstatus.editstatus.name')" v-model="status.display_name" />
          </div>
        </div>

        <div class="form-group mt-3">
          <label class="field-label" for="directionSelect">Direction</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text bg-white"><span class="mdi mdi-compass-outline"></span></span>
            </div>
            <select id="directionSelect" class="form-control" v-model="selectedDirections" multiple>
              <option value="arrival">Arrival</option>
              <option value="departure">Departure</option>
            </select>
          </div>
          <small class="form-text text-muted">Select one or both directions</small>

          <div class="chips mt-2" v-if="selectedDirections && selectedDirections.length">
            <span class="chip" v-for="dir in selectedDirections" :key="dir">
              <span class="mdi" :class="dir==='arrival' ? 'mdi-airplane-landing' : 'mdi-airplane-takeoff'"></span>
              {{ dir === 'arrival' ? 'Arrival' : 'Departure' }}
            </span>
          </div>
        </div>

        <div v-if="this.$router.currentRoute.name == 'edit-status'" class="custom-control custom-switch mt-4">
          <input type="checkbox" class="custom-control-input" id="customSwitches" v-model="status.is_active" />
          <label class="custom-control-label" for="customSwitches">{{ $t('flightstatus.editstatus.isactive') }}</label>
        </div>
      </div>
      <div class="card-footer bg-white border-0 d-flex justify-content-end gap-2 pb-4">
        <button v-if="this.$router.currentRoute.name == 'new-status'" class="btn btn-success mx-1" @click="addStatus">
          <span class="mdi mdi-content-save-outline mr-1"></span>{{ $t('flightstatus.newStatus.status-btn') }}
        </button>
        <button v-if="this.$router.currentRoute.name == 'edit-status'" class="btn btn-primary mx-1" @click="updateStatus($route.params.editid)">
          <span class="mdi mdi-content-save-edit-outline mr-1"></span>{{ $t('flightstatus.editstatus.btn') }}
        </button>
        <button class="btn btn-light mx-1" @click="$router.push({name: routeNames.manageStatus})">
          <span class="mdi mdi-close-circle-outline mr-1"></span>Cancel
        </button>
      </div>
    </div>
  </div>
  </PortalPageShell>
</template>
<script>
import PortalPageShell from '../layout/PortalPageShell.vue';
import axios from 'axios';
import { routeNames } from '../../js/routeNames';
export default {
  name: 'Status',
  components: {
    PortalPageShell,
  },
  data: function () {
    return {
      loading: false,
      statusData: '',
      switchValue: false,
      status: {
        display_name: '',
        is_active: '',
        direction: '',
      },
      nameCheck: '',
      selectedDirections: []
    };
  },
  mounted() {
    if(this.$router.currentRoute.name == 'edit-status'){
      this.status.display_name = this.$route.params.display_name;
      this.status.is_active = this.$route.params.is_active;
      this.nameCheck = this.$route.params.display_name;
      if (this.$route.params.direction) {
        const dir = this.$route.params.direction;
        this.status.direction = dir;
        if (dir === 'both') {
          this.selectedDirections = ['arrival', 'departure'];
        } else if (dir === 'arrival' || dir === 'departure') {
          this.selectedDirections = [dir];
        }
      }
    }
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },
    pageTitle() {
      return this.$router.currentRoute.name === 'new-status'
        ? this.$t('flightstatus.newStatus.title')
        : this.$t('flightstatus.editstatus.title');
    },
  },
  methods: {
    getOne(idx) {
      axios.get(this.$hostName + '/status/' + idx).then((response) => {
        this.statusData = response.data;
      });
    },
    addStatus(){
      if(this.status.display_name==''){
        this.$alert('Enter Flight Status Name');
      }
      else if (!this.selectedDirections || this.selectedDirections.length === 0) {
        this.$alert('Select Direction');
      }
      else{
        this.loading =  true;
        const dir = this.selectedDirections.length === 2 ? 'both' : this.selectedDirections[0];
        this.status.direction = dir;
        this.status.is_active = true;
        axios.post(this.$hostName + '/status/store',{
          status: this.status
        })
        .then( response =>{
          if(response.status==202){
              this.loading = false;
              this.$alert('Flight Status Already Exists');
            }
          else{
            this.status.display_name='';
            this.selectedDirections = [];
            this.loading =  false;
            this.$router.push({name:routeNames.manageStatus});
          }
        })
        .catch(error=>{
          console.log(error);
        });
      }
    },
    updateStatus(idx) {
      if (this.status.display_name == '') {
        this.$alert('Enter Flight Status Name');
      } else if (!this.selectedDirections || this.selectedDirections.length === 0) {
        this.$alert('Select Direction');
      } else {
        this.loading = true;
        const dir = this.selectedDirections.length === 2 ? 'both' : this.selectedDirections[0];
        this.status.direction = dir;
        axios
          .put(this.$hostName + '/status/' + idx, {
            status: this.status,
            nameCheck: this.nameCheck
          })
          .then((response) => {
            if (response.status == 202) {
              this.loading = false;
              this.$alert('Flight Status already exists');
            } else {
              this.loading = false;
              this.$router.push({name: routeNames.manageStatus});
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    goToRoute(route) {
      if (this.navOpen) this.toggleNav();
      if (route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    },
  },
};
</script>
<style scoped>
.loader {
  /* Loader Div Class */
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  background-color: #eceaea;
  background-image: url('../../assets/loading.gif');
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
  opacity: 0.4;
  filter: alpha(opacity=40);
}

.field-label {
  font-weight: 600;
  color: #3f3f40;
}
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f0f7ff;
  border: 1px solid #d9ecff;
  color: #2e6ea6;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
}
.chip .mdi {
  font-size: 16px;
}
.card {
  border-radius: 10px;
  border: 1px solid #eef2f7;
}
.card-header {
  border-bottom: none;
}
.card-footer {
  border-top: none;
}
.input-group-text {
  border-right: 0;
}
.input-group .form-control {
  border-left: 0;
}

/* Ensure footer buttons don't get cut off on smaller screens */
.edit-status {
  padding-bottom: 96px;
}
.card-footer {
  position: sticky;
  bottom: 8px;
  background: #fff;
  z-index: 5;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.03);
}

@media (max-width: 992px) {
  .edit-status {
    padding-bottom: 120px;
  }
  .card-footer {
    bottom: 16px;
  }
}
</style>
